module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f9b8-1f3fb-200d-2640-fe0f.e5afc4c6.svg";